import React, { Fragment, useEffect } from 'react';
import objectPropertyValueGetSet from "../Function/ObjectPropertyValueGetSet";
import PageDependencies from './PageDependencies';

const BindedInput = (props) => {
    const { useState } = PageDependencies();
    const newProps = {};
    const binding = props.binding;
    const dp = props.dp;
    let type = props.type;
    if (type === undefined) {
        type = "";
    } else {
        type = type.toLowerCase();
    }
    const bindingObject = binding[0];
    const bindingProperty = binding[1];
    const bindingMethod = binding[2];
    let bindingDefaultValue = binding[3];
    const bindingValue = objectPropertyValueGetSet.getPropertyValue(bindingObject, bindingProperty);
    const [message, setMessage] = useState("");
    const [value, setValue] = useState(bindingValue);
    const validate = props.validate;

    for (const prop in props) {
        if (!(prop === 'binding') && !(prop === 'componentRef') && !(prop === 'validate')) {
            newProps[prop] = props[prop];
        }
    }

    useEffect(() => {
        if (validate !== undefined) {
            if (validate.setMessages !== undefined) {
                validate.setMessages[1](oldSetMessage => {
                    let newMessages = {};
                    if (oldSetMessage !== undefined) {
                        newMessages = { ...oldSetMessage };
                    }
                    newMessages[bindingProperty] = setMessage;
                    return newMessages;
                });
            }
        }
    }, []);

    useEffect(() => {
        let newValue = roundTo(value);
        let newBindingValue = roundTo(bindingValue);
        if (newBindingValue != newValue) {
            setValue(newBindingValue);
        }
    }, [bindingValue]);

    useEffect(() => {
        const timer = setTimeout(() => {
            let newValue = roundTo(value);
            let newBindingValue = roundTo(bindingValue);
            if (newBindingValue != newValue) {
                const bindingObjectNew = {};
                bindingObjectNew[bindingProperty] = newValue;
                bindingMethod(bindingObjectNew, undefined, newValue, undefined, bindingDefaultValue);
            }
            if (validate !== undefined) {
                const validateObject = { ...bindingObject };
                validateObject[bindingProperty] = newValue;
                validate.checkValidateResult(validateObject);
            }
        }, 300);
        return () => {
            clearTimeout(timer);
        };
    }, [value]);

    const getValidateVisibility = () => {
        if (validate === undefined) return false;
        if (validate.validateVisibility === undefined) return false;
        return validate.validateVisibility;
    }

    function roundTo(value) {
        if (dp !== undefined) {
            try {
                const num = Number(value);;
                return Number(num.toFixed(dp));
            } catch (err) {
                console.log(err);
                return value
            }
        }
        return value;
    }

    return (
        <Fragment>
            {type === "file" && <input {...newProps} value={value} ref={props.componentRef} onChange={(e) => {
                let value = e.target.value
                setValue(value);
            }} />}
            {type !== "file" && <input {...newProps} ref={props.componentRef} value={roundTo(value)} onChange={(e) => {
                let value = e.target.value
                setValue(roundTo(value));
            }} />}
            {<span id={bindingProperty + "-Validate"} className="field-validation-valid" style={{ color: "red" }}>{getValidateVisibility() && message}</span>}
        </Fragment>
    );
};
export default BindedInput;